'use client';

import { c as _c } from "react/compiler-runtime";
import { type PostSignupStep, SEEN_ACTIVATION_FUNNEL_KEY } from '@shared/all/domains/onboarding';
import { createContext, type PropsWithChildren, useState } from 'react';
const AuthWidgetContext = createContext({
  loginModalOpen: false,
  signupModalOpen: false,
  // "Join factiii" opens the pre-auth funnel; the signup form slides in at its end.
  funnelOpen: false,
  authContinueModalOpen: false,
  logoutModalOpen: false,
  isAddAccountMode: false,
  setAuthContinueModalOpen: (_bool: boolean) => {},
  setLogoutModalOpen: (_bool: boolean) => {},
  setLoginModalOpen: (_bool: boolean) => {},
  setSignupModalOpen: (_bool: boolean) => {},
  setFunnelOpen: (_bool: boolean) => {},
  openAuthContinueModal: () => {},
  openLogoutModal: () => {},
  openLoginModal: () => {},
  // openSignupModal is the "Join factiii" entry: it shows the funnel first.
  openSignupModal: () => {},
  // The post-signup flow is one modal that steps through its panels, so one
  // value says both whether it is open and where it is: 'verify' (bot-account
  // alert + verification prompt), 'founders' (the founders offer) or 'done'
  // ("you're set" plus the recovery-email offer). null = closed.
  postSignupStep: null as PostSignupStep | null,
  setPostSignupStep: (_step: PostSignupStep | null) => {},
  // Opens that flow at its first step; what every signup path calls.
  openPostSignup: () => {},
  openLoginForAddAccount: () => {}
});
export const AuthWidgetContextProvider = t0 => {
  const $ = _c(18);
  const {
    children
  } = t0;
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [signupModalOpen, setSignupModalOpen] = useState(false);
  const [funnelOpen, setFunnelOpen] = useState(false);
  const [postSignupStep, setPostSignupStep] = useState(null);
  const [authContinueModalOpen, setAuthContinueModalOpen] = useState(false);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isAddAccountMode, setIsAddAccountMode] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = open => {
      setLoginModalOpen(open);
      if (!open) {
        setIsAddAccountMode(false);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setAuthContinueModalOpen(true);
    t3 = () => setLogoutModalOpen(true);
    t4 = () => setLoginModalOpen(true);
    t5 = () => {
      const seenFunnel = typeof window !== "undefined" && window.localStorage?.getItem(SEEN_ACTIVATION_FUNNEL_KEY) === "1";
      if (seenFunnel) {
        setSignupModalOpen(true);
      } else {
        setFunnelOpen(true);
      }
    };
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setPostSignupStep("verify");
    t7 = () => {
      setIsAddAccountMode(true);
      setLoginModalOpen(true);
    };
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  let t8;
  if ($[7] !== authContinueModalOpen || $[8] !== funnelOpen || $[9] !== isAddAccountMode || $[10] !== loginModalOpen || $[11] !== logoutModalOpen || $[12] !== postSignupStep || $[13] !== signupModalOpen) {
    t8 = {
      loginModalOpen,
      signupModalOpen,
      funnelOpen,
      authContinueModalOpen,
      logoutModalOpen,
      isAddAccountMode,
      setAuthContinueModalOpen,
      setLogoutModalOpen,
      setLoginModalOpen: t1,
      setSignupModalOpen,
      setFunnelOpen,
      openAuthContinueModal: t2,
      openLogoutModal: t3,
      openLoginModal: t4,
      openSignupModal: t5,
      postSignupStep,
      setPostSignupStep,
      openPostSignup: t6,
      openLoginForAddAccount: t7
    };
    $[7] = authContinueModalOpen;
    $[8] = funnelOpen;
    $[9] = isAddAccountMode;
    $[10] = loginModalOpen;
    $[11] = logoutModalOpen;
    $[12] = postSignupStep;
    $[13] = signupModalOpen;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const contextValue = t8;
  let t9;
  if ($[15] !== children || $[16] !== contextValue) {
    t9 = <AuthWidgetContext.Provider value={contextValue}>{children}</AuthWidgetContext.Provider>;
    $[15] = children;
    $[16] = contextValue;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default AuthWidgetContext;